import { createSelector } from "@reduxjs/toolkit";
import type { ICalculateEarthingInput } from "@multiconsult-group/multiplacer-core";
import {
  selectProjectViewerMcbimItems,
  type IProjectViewerMcbimItem,
} from "../projectViewerSelectors";

type IProjectViewerEarthingPoint2d =
  ICalculateEarthingInput["apparatusFoundations"][number]["points"][number];

const getProjectViewerItemEarthingPoints = (
  item: IProjectViewerMcbimItem
): IProjectViewerEarthingPoint2d[] => {
  const points = item.bbox ?? item.polygon ?? [];

  return points
    .map((point): IProjectViewerEarthingPoint2d | null => {
      const [x, y] = point;
      if (typeof x !== "number" || typeof y !== "number") return null;
      return [x, y];
    })
    .filter((point): point is IProjectViewerEarthingPoint2d => point != null);
};

export const selectProjectViewerEarthingCalculationInput = createSelector(
  [selectProjectViewerMcbimItems],
  (mcbimItems): ICalculateEarthingInput | null => {
    const apparatusFoundations = mcbimItems
      .filter((item) => item.typeName?.trim().startsWith("Apparatfundament"))
      .map((item) => ({
        id: item._id,
        points: getProjectViewerItemEarthingPoints(item),
      }))
      .filter((foundation) => foundation.points.length > 0);

    if (!apparatusFoundations.length) return null;

    return {
      apparatusFoundations,
    };
  }
);
